import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    addonContent: {
      [theme.breakpoints.down('xs')]: {
        // paddingTop: '20px',
      },
    },
    selectedCount: {
      backgroundColor: '#F8F8F8',
      borderRadius: '40px',
      height: '40px',
      width: '160px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      userSelect: 'none',
    },
  }),
  { name: 'Addons' },
);

export default useStyles;
